/**
 * Construit le libellé lisible d'une mission pour le fil d'Ariane
 * (ex: "CTO - Loïc Calvy chez Hermès"). Retourne `undefined` faute de label exploitable.
 */
export const buildMissionBreadcrumbLabel = ({
  label,
  bloomerFullName,
  clientName,
}: {
  label?: string | null;
  bloomerFullName?: string | null;
  clientName?: string | null;
}): string | undefined => {
  if (!label) return undefined;
  const base = [label, bloomerFullName].filter(Boolean).join(' - ');
  return clientName ? `${base} chez ${clientName}` : base;
};
